import { trackClientEvent } from '../../../../../trackClientEvent';
export const eventKey = 'product_info-eco_friendly_information_learn_more_cta-click';
/**
 * The user clicks on the Learn More CTA in the Eco-friendly information accordion, within the PDP
 */
export function trackProductInfoEcoFriendlyInformationLearnMoreCtaClick() {
    return trackClientEvent({
        eventKey,
        realTimeTracking: false,
    });
}
